import { render, staticRenderFns } from "./DefaultModal.vue?vue&type=template&id=655bf116&"
import script from "./DefaultModal.vue?vue&type=script&lang=js&"
export * from "./DefaultModal.vue?vue&type=script&lang=js&"
import style0 from "./DefaultModal.vue?vue&type=style&index=0&id=655bf116&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./DefaultModal.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports